import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
let ToolApi = class ToolApi {
    constructor(urls, http) {
        this.urls = urls;
        this.http = http;
    }
    postAccountInfoSave(params) {
        return this.http.post({
            url: this.urls.account.postAccountInfoSave,
            data: params,
        });
    }
    getAccountInfoList(params) {
        return this.http.get({
            url: this.urls.account.getAccountInfoList,
            params,
        });
    }
    getBehaviorAccountInfoSummary(account_id) {
        const url = this.urls.account.getBehaviorAccountInfoSummary;
        return this.http.get({
            url,
            params: { account_id: account_id },
        });
    }
};
ToolApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.ToolUrls)),
    __param(1, inject(Symbols.ToolHttp)),
    __metadata("design:paramtypes", [Object, Object])
], ToolApi);
export { ToolApi };
